import "whatwg-fetch"
import MD5 from "js-md5";


export const serialize = (obj) => {

}

export async function getSources(url, params) {
    // console.log(params)
    let str = Object.keys(params).map((item) => `${item}=${params[item]}`).join("&")
    let string
    if (str) {
        string = str + `&key=0xwsi8woc38gq2u2zjhtv6entu28bgtz`
    } else {
        string = str + `key=0xwsi8woc38gq2u2zjhtv6entu28bgtz`
    }

    let sign = MD5(string)

    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            token: '2345n45k4n63k63n3'
        },
        body: str + `&sign=${sign}`
    }).catch((error) => {
        console.log(error)
    })

    return await response.json().catch((error) => {
        console.log(error)
    })
}
export async function getSource(url) {
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    }).catch((error) => {
        console.log(error)
    })

    return await response.json().catch((error) => {
        console.log(error)
    })
}






// WEBPACK FOOTER //
// ./src/api.js